import { useMutation } from "@tanstack/react-query";
import { getFormTransaction, confirmTransaction, sendOrder, reverseTransaction, 
createInscriptionOneClick, confirmInscriptionOneClick, deleteInscriptionOneClick, authorizePayOneClick,
reverseOneClickTransaction, sendOrderEmail, createOrder  } from "../api";

export const useFormTransaction = () => {
  const query = useMutation({
    mutationKey: ['webpayformRequest'],
    mutationFn: getFormTransaction,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useConfirmTransaction = () => {
  const query = useMutation({
    mutationKey: ['webpayConfirmTransaction'],
    mutationFn: confirmTransaction,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useReverseTransaction = () => {
  const query = useMutation({
    mutationKey: ['webpayReverseTransaction'],
    mutationFn: reverseTransaction,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useSendOrder = () => {
  const query = useMutation({
    mutationKey: ['sendOrder'],
    mutationFn: sendOrder,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useSendOrderEmail = () => {
  // Sin onSuccess/onError decorativos: la mutación debe propagar el rechazo
  // tal cual a quien la invoque (useSendQrEmail), que es donde se decide el
  // toast y se reporta a Sentry con el contexto del pedido.
  const query = useMutation({
    mutationKey: ['useSendOrderEmail'],
    mutationFn: sendOrderEmail,
  });
  return query;
};

export const useCreateInscriptionOneClick = () => {
  const query = useMutation({
    mutationKey: ['useCreateInscriptionOneClick'],
    mutationFn: createInscriptionOneClick,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useConfirmInscriptionOneClick = () => {
  const query = useMutation({
    mutationKey: ['useConfirmInscriptionOneClick'],
    mutationFn: confirmInscriptionOneClick,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useDeleteInscriptionOneClick = () => {
  const query = useMutation({
    mutationKey: ['useDeleteInscriptionOneClick'],
    mutationFn: deleteInscriptionOneClick,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useAuthorizePayOneClick = () => {
  const query = useMutation({
    mutationKey: ['useAuthorizePayOneClick'],
    mutationFn: authorizePayOneClick,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useReverseOneClickTransaction = () => {
  const query = useMutation({
    mutationKey: ['useReverseOneClickTransaction'],
    mutationFn: reverseOneClickTransaction,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useCreateOrder = () => {
  const query = useMutation({
    mutationKey: ['createOrder'],
    mutationFn: createOrder,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};